const extractTextFromRawSlices = sliceBody => {
  return flatten(
    sliceBody.map(slice => {
      return recursiveFindSignature(slice.primary, x => {
        return x.type && x.text && x.spans
      })
    })
  )
    .filter(Boolean)
    .map(({ text }) => text)
}

const flatten = arr => [].concat(...arr)

const recursiveFindSignature = (obj, matcher) => {
  if (!obj) return null

  if (Array.isArray(obj)) {
    return flatten(obj.map(i => recursiveFindSignature(i, matcher))).filter(
      Boolean
    )
  }

  if (typeof obj === 'string' || typeof obj === 'number') {
    return null
  }

  if (matcher(obj)) {
    return obj
  }

  return flatten(
    Object.entries(obj).map(([key, val]) => {
      return recursiveFindSignature(val, matcher)
    })
  ).filter(Boolean)
}

module.exports = extractTextFromRawSlices
